/* eslint-disable no-console */
// Must run before keycloak-js: polyfills crypto.randomUUID + crypto.subtle.digest
// on insecure (plain-HTTP) contexts so SSO login works without HTTPS. No-op on HTTPS.
import 'app/auth/insecureCryptoPolyfill';
import React from 'react';
import { render } from 'react-dom';
import { Buffer } from 'buffer';

import affectliSso from 'app/auth/affectliSso';
import { showScriptError } from 'app/utils/html/script';

import * as serviceWorkerRegistration from './registerServiceWorker';

import { MainApp } from './App';

global.Buffer = Buffer;
window.addEventListener('beforeinstallprompt', event => {
    event.preventDefault();
    window.beforeInstallPromptAffectli = event;
});

async function loadKeycloak() {
    // Guard against a hung init (Keycloak unreachable / slow network before the
    // adapter rejects) leaving the user on an indefinite "Loading..." screen.
    // Legitimate paths either resolve (timer cleared) or navigate away to the
    // Keycloak login page (timer dies with the page), so this only fires on a
    // genuine stall.
    const initTimeoutMs = 15000;
    let timeoutId;
    const initTimeout = new Promise((resolve, reject) => {
        timeoutId = setTimeout(() => {
            console.error('[auth] TIMEOUT: Login took longer than 15s');
            reject(new Error('Login is taking too long. Check that the Keycloak server is reachable.'));
        }, initTimeoutMs);
    });

    try {
        // The Keycloak adapter now ships via the `keycloak-js` npm package
        // (bundled at build time) instead of being loaded from the Keycloak
        // server at runtime. loadConfig() points the adapter at
        // /config/keycloak.json; the adapter fetches that config itself during
        // initialized() -> init(), so the backend stays the config source.
        console.log('[auth] 1. Configuring Keycloak adapter...');
        affectliSso.loadConfig();

        console.log('[auth] 2. Calling affectliSso.initialized()...');
        await Promise.race([affectliSso.initialized(), initTimeout]);
        clearTimeout(timeoutId);

        console.log('[auth] 3. SSO initialized, rendering app');
        render(<MainApp />, document.getElementById('root'));
    } catch (error) {
        clearTimeout(timeoutId);
        console.error('[auth] SSO initialization failed:', error);
        // Expired/invalid refresh tokens trigger an automatic logout inside
        // affectliSso.init() which redirects to the Keycloak login page.
        // Showing a fatal-looking error during that navigation creates a brief
        // red flash. Soft-handle it.
        if (affectliSso.getIsInvalidSession && affectliSso.getIsInvalidSession()) {
            const loadingTextElem = document.querySelector('#loading-text');
            if (loadingTextElem) {
                loadingTextElem.textContent = 'Redirecting to login…';
            }
            return;
        }
        showScriptError(`SSO initialization failed: ${error.message || error}`);
    }
}

serviceWorkerRegistration.register();

loadKeycloak();
